import React from "react";

const TitleNewUser = (props) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <h1>{props.selectedUserId != "0" ? props.informacionUsuario.NombreSinEditar : "Nuevo usuario"}</h1>
            </div>
        </div>
    );
}

export default TitleNewUser;